(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-certifications-fold"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.yg-cert-fold').forEach(function (fold) {
    var btn = fold.querySelector('.yg-cert-fold__header');
    var content = fold.querySelector('.yg-cert-fold__content');

    if (!btn || !content) return;

    var collapsedLines = parseInt(fold.dataset.collapsedLines || '3', 10);

    function getCollapsedHeight() {
      var computedStyles = window.getComputedStyle(content);
      var lineHeight = parseFloat(computedStyles.lineHeight);

      if (!lineHeight) {
        lineHeight = parseFloat(computedStyles.fontSize) * 1.6;
      }

      return Math.ceil(lineHeight * collapsedLines);
    }

    function applyCollapsedState() {
      var collapsedHeight = getCollapsedHeight();
      content.style.setProperty('--collapsed-height', collapsedHeight + 'px');
      content.style.maxHeight = collapsedHeight + 'px';
      btn.setAttribute('aria-expanded', 'false');
      fold.setAttribute('aria-open', 'false');
      content.classList.remove('is-expanded');
    }

    function applyExpandedState() {
      content.style.maxHeight = content.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
      fold.setAttribute('aria-open', 'true');
      content.classList.add('is-expanded');
    }

    applyCollapsedState();

    btn.addEventListener('click', function () {
      var isExpanded = content.classList.contains('is-expanded');

      if (isExpanded) {
        applyCollapsedState();
      } else {
        applyExpandedState();
      }
    });

    window.addEventListener('resize', function () {
      if (content.classList.contains('is-expanded')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = getCollapsedHeight() + 'px';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-collapse-button"] && !Shopify.designMode) return;
  try {
    class YGCollapseButton extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl;

      this.#sectionEl = {
        targetEl: document.querySelector(`.${this.getAttribute('data-target-class')}`),
        buttonLabel: this.querySelector('.yg-link-label'),
      };

      return this.#sectionEl;
    }
    connectedCallback() {
      if (!this.$sectionEl['targetEl']) return;
      this.init();
      this.addEventListener('click', this.itemClick);
      this.$sectionEl['targetEl'].addEventListener('click', () => {
        this.init();
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    init() {
      const target = this.$sectionEl['targetEl'];

      if (!target.classList.contains('yg-collapse-target-el')) {
        target.classList.add('yg-collapse-target-el');
      }

      if (target.hasAttribute('open')) {
        target.style.height = 'auto';
      } else {
        target.style.height = '0px';
      }
    }

    openSection() {
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 先把高度设为当前像素值，再过渡到内容高度
      target.style.height = target.offsetHeight + 'px';

      // 强制浏览器重新计算一次布局，确保过渡生效
      target.offsetHeight;

      const endHeight = target.scrollHeight;
      target.style.height = endHeight + 'px';
      target.setAttribute('open', '');
      this.setAttribute('open', '');
      buttonLabel.innerText = this.getAttribute('data-less-label');

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;
        target.style.height = 'auto'; // 过渡结束后改为 auto，后续内容高度变化自动适应
        target.removeEventListener('transitionend', onTransitionEnd);
      };

      target.addEventListener('transitionend', onTransitionEnd);
    }

    closeSection() {
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 从 auto 变成具体高度，再过渡到 0
      if (getComputedStyle(target).height === 'auto') {
        target.style.height = target.scrollHeight + 'px';
      } else if (!target.style.height || target.style.height === '0px') {
        // 已经是收起或未设置高度，直接返回
        target.removeAttribute('open');
        target.style.height = '0px';
        return;
      }

      // 强制重新计算
      target.offsetHeight;

      target.style.height = '0px';
      target.removeAttribute('open');
      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute('data-more-label');
    }

    itemClick() {
      const target = this.$sectionEl['targetEl'];
      if (target.hasAttribute('open')) {
        this.closeSection();
      } else {
        this.openSection();
      }
    }
  }
  if (!window.customElements.get('yg-collapse-button')) {
    window.customElements.define('yg-collapse-button', YGCollapseButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
    #dropdownGroup;
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.debouncedResize = this.debounce(() => this.setContentContainerHeight(), 100);
    }

    get dropdownGroup() {
      if (this.#dropdownGroup) return this.#dropdownGroup;

      let groupID = this.dataset.group;
      if (!groupID) return null;

      this.#dropdownGroup = Array.from(
        this.closest('.shopify-section').querySelectorAll('yg-dropdown[data-group="' + groupID + '"]')
      );

      return this.#dropdownGroup;
    }
    connectedCallback() {
      setTimeout(() => {
        this.dropdownGroup[0]?.openDropdown();
      }, 60);
      this.titleContainer = this.querySelector('.yg-dropdown-title-container');
      if (this.titleContainer) {
        this.titleContainer.addEventListener('click', this.itemClick);
        window.addEventListener('resize', this.debouncedResize);
        this.setContentContainerHeight();
      }
    }
    disconnectedCallback() {
      if (this.titleContainer) {
        this.titleContainer.removeEventListener('click', this.itemClick);
      }
      if (this.debouncedResize) {
        window.removeEventListener('resize', this.debouncedResize);
      }
    }
    itemClick() {
      this.setContentContainerHeight();
      let group = this.dropdownGroup;
      if (group && Array.isArray(group) && this.hasAttribute('open')) {
        return;
      }

      this.hasAttribute('open') ? this.closeDropdown() : this.openDropdown();
    }

    openDropdown() {
      let group = this.dropdownGroup;
      if (group && Array.isArray(group)) {
        group.forEach((dropdown) => {
          if (dropdown !== this) {
            dropdown.closeDropdown();
          }
        });
      }

      this.setAttribute('open', '');
      document.dispatchEvent(
        new CustomEvent('YG:dropdown-open', {
          bubbles: true,
          composed: true,
          detail: {
            id: this.getAttribute('data-id'),
          },
        })
      );
    }

    closeDropdown() {
      this.removeAttribute('open');
    }

    setContentContainerHeight() {
      let contentContainer = this.querySelector('.yg-dropdown-content-container');
      let content = this.querySelector('.yg-dropdown-content');
      if (contentContainer && content) {
        contentContainer.style.setProperty('--height', `${content.getBoundingClientRect().height}px`);
      }
    }
  }
  if (!window.customElements.get('yg-dropdown')) {
    window.customElements.define('yg-dropdown', YGDropdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sectionsEl = {
        'popupTemplate': this.querySelector('template') || this.querySelector('.yg-popup-template')
      }
      this.addEventListener('click', this.itemClick.bind(this));
    }

    itemClick() {
      if (!this.sectionsEl['popupTemplate']) return

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate: this.sectionsEl['popupTemplate'],
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends YGUtils {
    constructor() {
      super();
    }

    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'title-list': Array.from(this.children),
        'content-list': Array.from(
          document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || []
        ),
      };

      return this._sectionsEl;
    }

    get scrollWrapper() {
      return this.closest('.yg-scroll-wrapper');
    }

    get prevBtn() {
      return this.scrollWrapper?.querySelector('.yg-scroll-btn--prev');
    }

    get nextBtn() {
      return this.scrollWrapper?.querySelector('.yg-scroll-btn--next');
    }

    connectedCallback() {
      this.initTabs();
      this.addEventListener('click', (e) => {
        let item = e.target.closest('.tab-title');
        if (item) {
          let i = this.sectionsEl['title-list'].indexOf(item);
          this.itemClick(item, i);
        }
      });

      // 移动端左右按钮事件
      this.prevBtn?.addEventListener('click', () => this.stepTab(-1));
      this.nextBtn?.addEventListener('click', () => this.stepTab(1));

      // 监听移动端滚动更新按钮状态
      const scrollContainer = this.closest('.yg-scroll-container');
      if (scrollContainer) {
        scrollContainer.addEventListener('scroll', () => this.updateNavButtons(), { passive: true });
      }

      // 初始检测（等待渲染完成）
      requestAnimationFrame(() => this.updateNavButtons());
      window.addEventListener('resize', () => this.updateNavButtons());
    }

    initTabs() {
      this.sectionsEl['title-list']?.forEach((el, i) => {
        if (!el.classList.contains('tab-title')) {
          el.classList.add('tab-title');
        }

        if (i == 0) {
          el.classList.add('is-active');
        }
      });
      this.updateStyle(this.sectionsEl['title-list'][0]);

      this.sectionsEl['content-list'].forEach((el, i) => {
        if (!el.classList.contains('tab-content')) {
          el.classList.add('tab-content');
        }

        if (i == 0) el.classList.add('is-active');
      });
    }

    scrollTabIntoView(el) {
      const scrollContainer = this.closest('.yg-scroll-container');
      if (!scrollContainer) return;
      const containerRect = scrollContainer.getBoundingClientRect();
      const elRect = el.getBoundingClientRect();
      const elCenter = elRect.left + elRect.width / 2;
      const containerCenter = containerRect.left + containerRect.width / 2;
      const offset = elCenter - containerCenter;
      scrollContainer.scrollBy({ left: offset, behavior: 'smooth' });
    }

    itemClick(el, i) {
      // 如果已经激活则直接返回
      if (el.classList.contains('is-active')) return;

      this.scrollTabIntoView(el);
      this.toggleClass(el, i);
      requestAnimationFrame(() => this.updateNavButtons());
    }

    stepTab(direction) {
      const list = this.sectionsEl['title-list'];
      const activeIndex = list.findIndex((el) => el.classList.contains('is-active'));
      const nextIndex = activeIndex + direction;
      if (nextIndex < 0 || nextIndex >= list.length) return;
      const nextEl = list[nextIndex];
      this.scrollTabIntoView(nextEl);
      this.toggleClass(nextEl, nextIndex);
      requestAnimationFrame(() => this.updateNavButtons());
    }

    updateNavButtons() {
      // 仅在移动端（宽度 ≤ 767px）显示按钮
      if (window.innerWidth > 767) {
        this.prevBtn?.classList.remove('is-visible');
        this.nextBtn?.classList.remove('is-visible');
        return;
      }

      const list = this.sectionsEl['title-list'];
      const activeIndex = list.findIndex((el) => el.classList.contains('is-active'));

      // 有上一个 tab 才显示 prev 按钮
      if (activeIndex > 0) {
        this.prevBtn?.classList.add('is-visible');
      } else {
        this.prevBtn?.classList.remove('is-visible');
      }

      // 有下一个 tab 才显示 next 按钮
      if (activeIndex < list.length - 1) {
        this.nextBtn?.classList.add('is-visible');
      } else {
        this.nextBtn?.classList.remove('is-visible');
      }
    }

    toggleClass(el, i) {
      // 处理标题激活状态
      this.sectionsEl['title-list'].forEach((item) => {
        item.classList.remove('is-active');
      });
      el.classList.add('is-active');
      this.updateStyle(el);

      // 处理内容激活状态
      this.sectionsEl['content-list'].forEach((item) => {
        item.classList.remove('is-active');
      });
      if (this.sectionsEl['content-list'][i]) this.sectionsEl['content-list'][i].classList.add('is-active');
    }

    updateStyle(el = null) {
      let itemEl = el || this.querySelector('.is-active');

      if (!itemEl) return;
      let left = itemEl.offsetLeft;
      let width = itemEl.offsetWidth;
      this.style.setProperty('--scroll-item-left', `${left}px`);
      this.style.setProperty('--scroll-item-width', `${width}px`);
    }
  }
  if (!window.customElements.get('yg-tabs-title')) {
    window.customElements.define('yg-tabs-title', YGTabsTitle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.type = this.getAttribute('data-type');
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get playVideoButton() {
      return this.querySelector('.yg-play-video');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('hide');
      this.playVideoButton?.classList.add('hide');

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        
        this.videoContainer.classList.remove('hide');
        videos.forEach(video => {
          video.play();
        });

        return;
      }

      this.appendChild(this.template?.content.cloneNode(true));
    }

    pauseVideo() {
      this.image?.classList.remove('hide');
      this.playVideoButton?.classList.remove('hide');
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        this.videoContainer.classList.add('hide');

        videos.forEach(video => {
          video.pause();
          video.currentTime = 0;
        });
      } else {
        this.videoContainer?.remove();
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
